import { createBrowserRouter, Navigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { AuthGuard } from "./AuthGuard";
import { RegistrationGuard } from "./RegistrationGuard";

// Lazy load pages for code splitting
import { LoginPage } from "@/features/auth/components/LoginPage";
import { ForgotPasswordPage } from "@/features/auth/components/ForgotPasswordPage";
import { RecoverPasswordPage } from "@/features/auth/components/RecoverPasswordPage";
import { SplashScreen } from "@/features/auth/components/SplashScreen";
import { DashboardLayout } from "@/components/DashboardLayout";
import { CategoriesView } from "@/features/category/components/CategoriesView";
import { ExtrasView } from "@/features/extras/components/ExtrasView";
import { ProductsView } from "@/features/product/components/ProductsView";
import { ProductFormPage } from "@/features/product/components/ProductFormPage";
import { SettingsView } from "@/features/settings/components/SettingsView";
import { RegisterPage } from "@/features/registration/components/RegisterPage";
import { VerifyEmailPage } from "@/features/registration/components/VerifyEmailPage";
import { SubscriptionPage } from "@/features/registration/components/SubscriptionPage";
import { normalizeLeadingSlashes } from "@/lib/location";

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

normalizeLeadingSlashes();

export const router = sentryCreateBrowserRouter([
  {
    path: "/",
    element: <SplashScreen />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/register",
    element: <RegisterPage />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />,
  },
  {
    path: "/recover-password/:token",
    element: <RecoverPasswordPage />,
  },
  {
    path: "/verify-email",
    element: (
      <RegistrationGuard requiredStatus="needsEmailVerification">
        <VerifyEmailPage />
      </RegistrationGuard>
    ),
  },
  {
    path: "/subscription",
    element: (
      <RegistrationGuard requiredStatus="needsSubscription">
        <SubscriptionPage />
      </RegistrationGuard>
    ),
  },
  {
    path: "/dash",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/dash/categories" replace />,
      },
      {
        path: "categories",
        element: <CategoriesView />,
      },
      {
        path: "extras",
        element: <ExtrasView />,
      },
      {
        path: "products",
        element: <ProductsView />,
      },
      {
        path: "products/new",
        element: <ProductFormPage />,
      },
      {
        path: "products/:id/edit",
        element: <ProductFormPage />,
      },
      {
        path: "settings",
        element: <SettingsView />,
      },
    ],
  },
]);
